export class ExtendedUse {
    proposer_equine: boolean = null;  
    proposer_non_equine: boolean = null;  
    driver_equine: boolean = null;  
    driver_non_equine: boolean = null;  
    livestock_carriage: boolean = null;  
    
}
